
// Need to load app.js (it can be loaded by other JSs in the view, but this is a little bit more clear)
import './app.js';

import {EN_US} from './data/strings.en_us.js';
import {MARKET_US} from './data/configs.us.js';
import {configManager, strings, birthdayPicker, CommonApp} from '@nuskin/ns-common-account';

// Put functions/variables to window so that we can access them outside of windows
window.mecAccount = window.mecAccount || {};
window.mecAccount.MARKET_US = MARKET_US;
window.mecAccount.EN_US = EN_US;
window.mecAccount.configManager = configManager;
window.mecAccount.strings = strings;

// ***  Factories ***//
import './angular/factories/birthday-factory';

// ***  Components ***//
import './angular/directives/email-phone/email-phone.js';
import './angular/components/favorite-list/favorite-list-adapter.js';

// ***  Pages ***//
import './views/pages/personal/personal.js';
import './views/pages/business/business.js';

// ***  Services ***//
import './services/personal-service.js';
import './services/business-service.js';




//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 209
// module chunks = 0